export const INTEGRATION_TYPE = 'pinterest-inbound'
export const DATA_TYPE_KEY = 'data_type'

export const DATA_TYPES = [
  { type: 'ad_accounts', label: 'Ad Accounts' },
  { type: 'ad_groups', label: 'Ad Groups' },
  { type: 'ads', label: 'Ads' },
  { type: 'campaigns', label: 'Campaigns' },
] as const
